import { SET_LOGO_INFO_DATA } from '../actions/types';

export default function logoInfo(state = {}, action) {
	switch (action.type) {
		case SET_LOGO_INFO_DATA:
			return action.payload;
		default:
			return state;
	}
}
